<script>
/**
 * @overview 应用部分入口
 *
 * @author huojinzhao
 */

import { Loading as $loading } from "element-ui";
import $store from "@/store";

export default {
  name: "ViewMain",

  beforeRouteEnter(to, from, next) {
    const loadingInstance = $loading.service({
      customClass: "view-main-loading",
      lock: true,
      text: "正在加载初始化数据，请耐心等待...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const userInit = $store.dispatch("initUserInfo");
    const gameInit = $store.dispatch("game/initTypes");
    const materialInit = $store.dispatch("material/initTypes");
    const courseInit = $store.dispatch("course/initSubjects");

    Promise.all([
      userInit,
      gameInit,
      materialInit,
      courseInit,
    ])
      .then(() => {
        loadingInstance.close();

        next();
      });
  },
};
</script>

<template>
  <router-view />
</template>

<style lang="postcss">
.view-main-loading {
  font-size: 50px;
}

.view-main-loading .el-loading-text {
  font-size: 16px;
}
</style>

